import React from "react";
import { useSelector } from "react-redux";

import logo from "../assets/svg/logo_new.png";
import Whatsapp from "../assets/images/Whatsapp.svg";
import Telegram from "../assets/images/Telegram.svg";
import Facebook from "../assets/images/facebook-512.svg";
import Instagram from "../assets/images/Instagram.svg";
import TlgrmAffliate from "../assets/images/affliate-new.webp";

import Email from "../assets/images/email.svg";
import GPay from "../assets/images/pay-partners/gpay.svg";
import PhonePe from "../assets/images/pay-partners/phonepe.svg";
import UPI from "../assets/images/pay-partners/upi.svg";
import Paytm from "../assets/images/pay-partners/paytm.svg";

import Truste from "../assets/images/security/truste.webp";
import TrusteMob from "../assets/images/security/truste_mob.webp";
import McAfee from "../assets/images/security/mcafee.webp";
import McAfeeMob from "../assets/images/security/mcafee_mob.webp";
import SiteLock from "../assets/images/security/sitelock.webp";
import SiteLockMob from "../assets/images/security/sitelock_mob.webp";
import GamingCuracad from "../assets/images/security/gamingcuracad.webp";
import GamingCuracadMob from "../assets/images/security/gamingcuracad_mob.webp";

import SafeSecure from "../assets/images/safe-secure.svg";
import Plus18 from "../assets/images/age-18.svg";
import BeGambleAware from "../assets/images/gamble.svg";

const Footer = () => {
  const { user } = useSelector((state) => state.auth);
  const { appDetails } = useSelector((state) => state.app);

  return (
    <footer className="footer">
      <div className="inner-wrapper mx-auto">
        <div className="topLeft_footer">
          <h2 className="mb-4">Customer Support</h2>
          <div className="menu-items">
            <a href="mailto:support@prada365.com" className="item">
              <img src={Email} alt="email" className="mail" />
              <span>support@prada365.com</span>
            </a>
          </div>

          <h2 className="mb-3">Company Information</h2>
          <div className="menu-items">
            <a href="/responsiblegame" className="item">
              <span>Responsible Gaming</span>
            </a>
            <a href="/privacypolicy" className="item">
              <span>Privacy Policy</span>
            </a>
            <a href="/fairplay" className="item">
              <span>Fair Play</span>
            </a>
            <a href="/gamesrule" className="item">
              <span>Games Rules</span>
            </a>
            <a href="/contactus" className="item">
              <span>Contact Us</span>
            </a>
            <a href="/terms" className="item">
              <span>Terms & Conditions</span>
            </a>
          </div>
        </div>

        <div className="topRight_footer">
          <div className="footerContext_mob">
            <p className="my-3" style={{ fontSize: "1rem" }}>
              Prada365 is operated by Prime Operations N.V., a limited liability
              company incorporated under the laws of Curacao with company
              Registration number 175648 with registered office at Abraham de
              Veerstraat 11 , Curacao and is licensed and regulated by the
              Curacao authority as the regulatory body.
            </p>
          </div>

          <div className="gamingFooter">
            <div className="gamingLicense">
              <h2 className="showPC">100% Legal</h2>
              <img src={SafeSecure} alt="safe & secure" />
            </div>
            <div className="responsibleGaming">
              <h2 className="showPC">Responsible Gaming</h2>
              <div className="responsibleGaming_images">
                <img src={Plus18} alt="18 plus" />
                <a>
                  <img src={BeGambleAware} alt="be gamble aware" />
                </a>
              </div>
            </div>
          </div>

          <div className="social_download">
            <div className="socialMedia">
              <h2>Social Media</h2>
              <div className="socialMedia_icons">
                <a
                  className="panel"
                  href={
                    appDetails?.WHATS_APP_URL != ""
                      ? appDetails?.WHATS_APP_URL
                      : "#"
                  }
                  target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                >
                  <img src={Whatsapp} alt="Whatsapp" />
                </a>
                <a
                  href={
                    appDetails?.INSTATGRAM != "" ? appDetails?.INSTATGRAM : "#"
                  }
                  target={appDetails?.INSTATGRAM != "" ? "_blank" : ""}
                >
                  <img src={Instagram} alt="Instagram" />
                </a>
                <a
                  href={appDetails?.TELEGRAM != "" ? appDetails?.TELEGRAM : "#"}
                  target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                >
                  <img src={Telegram} alt="Telegram" />
                </a>
                <a
                  href={appDetails?.FACEBOOK != "" ? appDetails?.FACEBOOK : "#"}
                  target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                >
                  <img src={Facebook} alt="Facebook" />
                </a>
              </div>
            </div>
            {/* <a
              href={appDetails?.TELEGRAM != "" ? appDetails?.TELEGRAM : "#"}
              target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
              className="affiliate"
            >
              <img src={TlgrmAffliate} alt="Affiliate on Telegram" />
            </a> */}
          </div>

          <div className="providers">
            <img src={GPay} alt="GPay" style={{ height: "51px" }} />
            <img src={PhonePe} alt="PhonePe" style={{ height: "35px" }} />
            <img src={UPI} alt="UPI" style={{ height: "35px" }} />
            <img src={Paytm} alt="Paytm" style={{ height: "33px" }} />
          </div>

          <div className="footerContext">
            <p>
              Prada365 is operated by Prime Operations N.V., a limited liability
              company incorporated under the laws of Curacao with company
              Registration number 175648 with registered office at Abraham de
              Veerstraat 11 , Curacao and is licensed and regulated by the
              Curacao authority as the regulatory body.
            </p>
            <div className="security-section-content">
              <img src={Truste} alt="Truste" className="d-none d-xl-block" />
              <img src={TrusteMob} alt="Truste" className="d-xl-none" />
              <img src={McAfee} alt="McAfee" className="d-none d-xl-block" />
              <img src={McAfeeMob} alt="McAfee" className="d-xl-none" />
              <img
                src={SiteLock}
                alt="Site Lock"
                className="d-none d-xl-block"
              />
              <img src={SiteLockMob} alt="Site Lock" className="d-xl-none" />
              <img
                src={GamingCuracad}
                alt="Gaming Curacad"
                className="d-none d-xl-block"
              />
              <img
                src={GamingCuracadMob}
                alt="Gaming Curacad"
                className="d-xl-none"
              />
            </div>
          </div>

          <p className="footer_txt">
            Copyright ©2025 Prada365. All Rights Reserved.
          </p>
        </div>

        {/* <p>{appDetails?.FOOTER_TEXT || ""}</p> */}
      </div>
    </footer>
  );
};

export default Footer;
